translateFilter.$inject = ['i18n']

function translateFilter (i18n) {
  return function (input, options) {
    return i18n.translate(input, options)
  }
}

exports.translateFilter = translateFilter
